
import { Mail, Linkedin } from "lucide-react";
import { Link } from "react-router-dom";
export const Footer = () => {
  return <footer className="bg-black text-white px-5 md:px-10 py-11">
      <div className="max-w-[1230px] mx-auto">
        <div className="flex flex-col">
          <p className="text-[32px] leading-[1.13] font-medium">Message me on</p>
          
          <a href="https://www.linkedin.com/in/hibaganta/" target="_blank" rel="noopener noreferrer" className="mt-6 text-[40px] md:text-[120px] leading-[0.93] tracking-[-0.02em] hover:opacity-80 transition-opacity underline">
            LinkedIn
          </a>
        </div>

        <div className="mt-20 md:mt-[345px] flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          <div className="flex items-center gap-8">
            <a href="https://www.linkedin.com/in/hibaganta/" target="_blank" rel="noopener noreferrer" className="hover:opacity-80 transition-opacity">
              <Linkedin className="w-6 h-6" />
            </a>
          </div>

          <Link to="/impressum" className="text-[20px] leading-[1.13] font-medium underline hover:opacity-80 transition-opacity">
            Impressum
          </Link>

          <p className="leading-[1.13] font-medium text-lg">
            © 2025 Hiba Ganta. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
};
